/* eslint-disable no-nested-ternary */
import { Button, Grid, Checkbox, FormLabel } from '@material-ui/core';
import { Autocomplete, TextFieldPx, FormikTextFieldPx, FormikAutocompletePx, useMutation, useToast, useAuth } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import { updateStudentContract, getAddress, getCommunes } from '@webapps/business';
import { useFormik } from 'formik';
import { DEPARTMENTS, SITUATION_BEFORE_CONTRACT, LAST_DISPLOMA, LAST_DIPLOMA_YEAR, BEST_DIPLOMA, SEXES, NATIONALITY, YESNO, SOCIAL_REGIME } from 'config/constants';

import PhoneInput, {
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { FormattedMessage } from 'react-intl';

const StudentContract = ({ infosContract = [], refetchInfosContract }) => {
  const {
    classes,
    cx,
    css,
    theme: { spacing, fontSizes },
  } = useStyles(styles);

  const [addresses, setAddresses] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState('');

  const { addToast } = useToast();
  const { idUser } = useAuth();

  const {
    isSuccess,
    isError,
    mutateAsync: mutateUpdateStudentContract,
  } = useMutation(updateStudentContract);

  const getAddressInfo = useMutation(getAddress, {
    onSuccess: (result) => {
      setAddresses(result?.data?.features);

      const firstAddress = result?.data?.features[0]?.properties;
      formik.setFieldValue('legalCity', firstAddress?.city);
      formik.setFieldValue('legalPostalCode', firstAddress?.postcode);
    },
  });

  const getCommunesInfo = useMutation(getCommunes, {
    onSuccess: (result) => {
      setCommunes(result?.data);
    },
  });

  const handleChangeAddress = async (searchValue) => {
    if (!searchValue.target.value || searchValue.target.value.length < 3) {
      return null;
    }
    await getAddressInfo.mutateAsync({ name: searchValue.target.value });
  };

  const handleChangeCommunes = async (searchValue) => {
    if (!searchValue.target.value) {
      return null;
    }
    await getCommunesInfo.mutateAsync({ name: searchValue.target.value });
  };

  const handleSecurityNumber = (e) => {
    const value = e.target.value;
    let formattedValue = value.replace(/\D/g, '');

    if (e?.nativeEvent?.inputType === "deleteContentBackward" && socialSecurityNumber.slice(-1) === ' ') {
      formattedValue = formattedValue.slice(0, -1);
    }
  
    let formattedDisplayValue = '';
    if (formattedValue.length > 0) {
      formattedDisplayValue = formattedValue.slice(0, 1) + ' ' + 
                               formattedValue.slice(1, 3) + ' ' + 
                               formattedValue.slice(3, 5) + ' ' + 
                               formattedValue.slice(5, 7) + ' ' + 
                               formattedValue.slice(7, 10) + ' ' + 
                               formattedValue.slice(10, 13) + ' ' +
                               formattedValue.slice(13, 15);
    }
  
    const securityNumber = formattedValue.slice(0, 13);
    const securityNumberKey = formattedValue.slice(13, 15);
  
    formik.setFieldValue('socialSecurityNumber', securityNumber);
    formik.setFieldValue('socialSecurityNumberKey', securityNumberKey);
    setSocialSecurityNumber(formattedDisplayValue);
  };

  const formik = useFormik({
    initialValues: {
      sex: infosContract?.sex || null,
      disabled: infosContract?.disabled || "false",
      departmentBirth: infosContract?.departmentBirth || null,
      cityBirth: infosContract?.cityBirth || null,
      nameBirth: infosContract?.nameBirth || null,
      nationality: infosContract?.nationality || null,
      socialRegime: infosContract?.socialRegime || null,
      addressDetails: infosContract?.addressDetails || null,
      number: infosContract?.number || null,
      street: infosContract?.street || null,
      situationBeforeContract: infosContract?.situationBeforeContract || null,
      lastDiploma: infosContract?.lastDiploma || null,
      lastDiplomaYear: infosContract?.lastDiplomaYear || null,
      diplomaLabel: infosContract?.diplomaLabel || null,
      bestDiploma: infosContract?.bestDiploma || null,
      legalFirstname: infosContract?.legalFirstname || null,
      legalLastname: infosContract?.legalLastname || null,
      legalEmail: infosContract?.legalEmail || null,
      legalPhone: infosContract?.legalPhone || null,
      legalAddress: infosContract?.legalAddress || null,
      legalPostalCode: infosContract?.legalPostalCode || null,
      legalCity: infosContract?.legalCity || null,
      legalAddressDetails: infosContract?.legalAddressDetails || null,
      legalNumber: infosContract?.legalNumber || null,
      legalStreet: infosContract?.legalStreet || null,
      socialSecurityNumber: infosContract?.socialSecurityNumber || null,
      socialSecurityNumberKey: infosContract?.socialSecurityNumberKey || null,
      sportRegistered: infosContract?.sportRegistered ? true : false,
      entrepreneur: infosContract?.entrepreneur ? true : false,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      await mutateUpdateStudentContract({ id: idUser, data: {...values} });
    },
  });

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Informations mises à jour avec succès',
      });
      refetchInfosContract();
    } else if (isError) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if(infosContract?.socialSecurityNumber && infosContract?.socialSecurityNumberKey)
      handleSecurityNumber({ target: { value: `${infosContract?.socialSecurityNumber}${infosContract?.socialSecurityNumberKey}`} });
    if(infosContract?.cityBirth)
      formik.setFieldValue('cityBirth', infosContract?.cityBirth);
    if(infosContract?.legalAddress)
      formik.setFieldValue('legalAddress', infosContract?.legalAddress);

  }, [infosContract]);

  const [errorPhone, setErrorPhone] = useState(false);

  const [phoneClasses, setPhoneClasses] = useState('phoneInput');
  const phoneClassesRef = useRef();
  phoneClassesRef.current = phoneClasses;

  const handleChangePhone = (phoneInfo) => {
    if (phoneInfo) {
      if (isValidPhoneNumber(phoneInfo)) {
        formik.setFieldValue('legalPhone', phoneInfo);
        setErrorPhone(false);
        setPhoneClasses('phoneInput');
      } else {
        setErrorPhone(true);
        setPhoneClasses('phoneInputError');
      }
    }
  };

  return (
    <Grid spacing={3} xs={12} className={classes.container}>
      <Grid item md={12} className={classes.card}>
        <div className={classes.title}>Informations des données requises lors de la signature d'un contrat</div>
        <Grid container xs={12} className={classes.btnsContainer2}>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('sex', value?.value);
              }}
              label="Sexe"
              name="sex"
              options={SEXES}
              value={SEXES.find((option) => option?.value === formik.values.sex) || ''}
              />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('departmentBirth', value?.value);
              }}
              label="Département de naissance"
              name="departmentBirth"
              options={DEPARTMENTS}
              value={DEPARTMENTS.find((option) => option?.value === formik.values.departmentBirth) || ''}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <Autocomplete
              autoComplete={false}
              classes={{
                inputRoot: css({
                  minHeight: "50px !important",
                }),
              }}
              defaultValue=""
              getOptionSelected={(option, value) => option === value}
              inputValue={formik.values.cityBirth}
              onInputChange={(event, value) => {
                formik.setFieldValue('cityBirth', value);
                handleChangeCommunes({ target: { value } });
              }}
              options={communes?.map((option) => option?.nom)}
              renderInput={(params) => (
                <TextFieldPx
                  {...params}
                  label="Commune de naissance"
                  name="cityBirth"
                  onChange={(event) => {
                    formik.setFieldValue('cityBirth', event.target.value);
                    handleChangeCommunes({ target: { value: event.target.value } });
                  }}
                  placeholder="N° rue et code postal"
                  value={formik.values.cityBirth}
                  variant="outlined"
                />
              )}
              size="small"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Nom de naissance"
              name="nameBirth"
              value={formik.values.nameBirth}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('nationality', value?.value);
              }}
              label="Nationalité"
              name="nationality"
              options={NATIONALITY}
              value={NATIONALITY.find((option) => option?.value === formik.values.nationality) || null}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('disabled', value?.value);
              }}
              label="Travailleur Handicapé"
              name="disabled"
              options={YESNO}
              value={YESNO.find((o) => o.value === formik.values.disabled) || "false"}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('socialRegime', value?.value);
              }}
              label="Régime social"
              name="socialRegime"
              options={SOCIAL_REGIME}
              value={SOCIAL_REGIME.find((option) => option?.value === formik.values.socialRegime) || null}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Complément d'adresse (ex: étage, porte...)"
              name="addressDetails"
              value={formik.values.addressDetails}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="N° de rue"
              name="number"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Voie"
              name="street"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('situationBeforeContract', value?.value);
              }}
              label="Situation avant contrat"
              name="situationBeforeContract"
              options={SITUATION_BEFORE_CONTRACT}
              value={SITUATION_BEFORE_CONTRACT.find((option) => option?.value === formik.values.situationBeforeContract) || null}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('lastDiploma', value?.value);
              }}
              label="Dernier diplôme ou titre préparé"
              name="lastDiploma"
              options={LAST_DISPLOMA}
              value={LAST_DISPLOMA.find((option) => option?.value === formik.values.lastDiploma) || null}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('lastDiplomaYear', value?.value);
              }}
              label="Dernière classe / année suivie"
              name="lastDiplomaYear"
              options={LAST_DIPLOMA_YEAR}
              value={LAST_DIPLOMA_YEAR.find((option) => option?.value === formik.values.lastDiplomaYear) || null}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Intitulé précis du dernier diplôme ou titre préparé"
              name="diplomaLabel"
              value={formik.values.diplomaLabel}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              onChange={(event, value) => {
                formik.setFieldValue('bestDiploma', value?.value);
              }}
              label="Diplôme ou titre le plus élevé obtenu"
              name="bestDiploma"
              options={LAST_DISPLOMA}
              value={LAST_DISPLOMA.find((option) => option?.value === formik.values.bestDiploma) || null}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Nom du représentant légal"
              name="legalLastname"
              value={formik.values.legalLastname}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Prénom du représentant légal"
              name="legalFirstname"
              value={formik.values.legalFirstname}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Email du représentant légal"
              name="legalEmail"
              value={formik.values.legalEmail}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <PhoneInput
              className={classes[phoneClassesRef.current]}
              countryCallingCodeEditable={false}
              defaultCountry="FR"
              international
              limitMaxLength
              name="legalPhone"
              onChange={(phone) => {
                handleChangePhone(phone);
              }}
              placeholder={<FormattedMessage id="createUserForm.phone" />}
              value={formik.values.legalPhone}
            />
            <div className={classes.phoneError}>
              <div />
              <div>
                {errorPhone && (
                  <div className={css({ color: 'red' })}>
                    Le numéro n'est pas correct
                  </div>
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <Autocomplete
              autoComplete={false}
              classes={{
                inputRoot: css({
                  minHeight: "50px !important",
                }),
              }}
              defaultValue=""
              getOptionSelected={(option, value) => option === value}
              inputValue={formik.values.legalAddress}
              onInputChange={(event, value) => {
                formik.setFieldValue('legalAddress', value);
                handleChangeAddress({ target: { value } });
              }}
              options={addresses?.map((option) => option?.properties?.label)}
              renderInput={(params) => (
                <TextFieldPx
                  {...params}
                  label="Adresse du représentant légal"
                  name="legalAddress"
                  onChange={(event) => {
                    formik.setFieldValue('legalAddress', event.target.value);
                    handleChangeAddress({ target: { value: event.target.value } });
                  }}
                  value={formik.values.legalAddress}
                  variant="outlined"
                />
              )}
              size="small"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Complément d'adresse du représentant légal (ex: étage, porte...)"
              name="legalAddressDetails"
              value={formik.values.legalAddressDetails}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="N° de rue du représentant légal"
              name="legalNumber"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Voie du représentant légal"
              name="legalStreet"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <TextFieldPx
              fullWidth
              label="Numéro de sécurité sociale"
              onChange={(e) => handleSecurityNumber(e)}
              value={socialSecurityNumber}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormLabel style={{ color: '#152652', alignSelf: 'center' }}>Déclare être inscrit sur la liste des sportifs de haut niveau</FormLabel>
            <Checkbox
              className={css({ '.MuiIconButton-label': { color: '#152652 !important' } })}
              checked={formik.values.sportRegistered}
              name="sportRegistered"
              onChange={formik.handleChange}
              size="small"
              />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormLabel style={{ color: '#152652', alignSelf: 'center' }}>Déclare avoir un projet de création ou de reprise d'entreprise</FormLabel>
            <Checkbox
              className={css({ '.MuiIconButton-label': { color: '#152652 !important' } })}
              checked={formik.values.entrepreneur}
              name="entrepreneur"
              onChange={formik.handleChange}
              size="small"
              />
          </Grid>
          <Button
            className={classes.btnDelete}
            onClick={formik.handleSubmit}
            variant="contained"
          >
            Enregistrer
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    padding: spacing(2.5),
  },
  title: {
    fontWeight: 500,
    fontSize: fontSizes(18),
    color: '#152652',
    marginBottom: spacing(2.5),
    fontFamily: 'Rubik',
  },
  label: {
    //    fontSize: fontSizes(16),
    fontSize: fontSizes(16),
    fontWeight: 600,
    color: '#152652',
    '@media (max-width:1380px)': { fontSize: fontSizes(15) },
    '@media (max-width:1278px)': { fontSize: fontSizes(14), },
    '@media (max-width:1227px)': { fontSize: fontSizes(13), },
    '@media (max-width:1020px)': { fontSize: fontSizes(16), },
  },
  password: {
    marginLeft: spacing(2.5),
    marginBottom: spacing(2.5),
  },
  textfield: {
    marginBottom: spacing(2.5),
    flexBasis: 'auto',
  },
  textfieldName: {
    width: '49%',
  },
  infoBox: {
    padding: spacing(4, 2.5, 2.5, 1.5),
    borderRadius: '5px',
    color: '#152652',
    "-webkit-text-fill-color" : "#152652",
    fontSize: fontSizes(16),
    fontFamily: 'Rubik',
    height: '30px',
    backgroundColor: '#F8F8F8',
    display: 'flex',
    alignItems: 'center',
  },
  infoBoxDisabled: {
    borderRadius: '5px',
    color: '#959DB1',
    backgroundColor: '#FFFFFF',
  },
  btnCancel : {
    marginLeft: spacing(2),
    backgroundColor: 'crimson',
    '&:hover' : {
      backgroundColor: 'red',
    },
  },
  btnDelete: {
    marginTop: spacing(2.5),
    float: 'right',
    backgroundColor: 'crimson',
    '&:hover' : {
      backgroundColor: 'red',
    },
    '@media only screen and (max-width:506px)': { width: '100%', flexBasis: '100%' },
  },
  deleteAccount: {
    textAlign: 'center',
    marginBottom: '16px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  btnLogout: {
    marginTop: spacing(2.5),
    backgroundColor: 'white',
    '@media only screen and (max-width:506px)': { width: '100%', flexBasis: '100%' },
  },
  btnLogoutContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'self-end',
    flexWrap: 'wrap',
  },
  btnsContainer2: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  phoneInput: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F8F8F8',
      border: "2px solid #E9E9F0",
      borderRadius: 5,
      padding: spacing(4, 2),
      height: '100%',
      color: '#737373',
    },
  },
  phoneInputError: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F8F8F8',
      border: '2px solid red',
      borderRadius: 5,
      padding: spacing(4, 2),
      height: '100%',
      color: '#f44336',
    },
  },
  phoneError: {
    display: 'flex',
    width: '100%',
    '& > *': {
      width: '50%',
    },
  },
  phoneDisabled: {
    '& > *': {
      backgroundColor: 'white',
    },
  }
});

StudentContract.propTypes = {
  infosContract: PropTypes.object,
  refetchInfosContract: PropTypes.func,
};

export default StudentContract;
